import { render, staticRenderFns } from "./PermissionsManager.vue?vue&type=template&id=4e6ab392&"
import script from "./PermissionsManager.vue?vue&type=script&lang=js&"
export * from "./PermissionsManager.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsManager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src414009122/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e6ab392')) {
      api.createRecord('4e6ab392', component.options)
    } else {
      api.reload('4e6ab392', component.options)
    }
    module.hot.accept("./PermissionsManager.vue?vue&type=template&id=4e6ab392&", function () {
      api.rerender('4e6ab392', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Config/PermissionsManager.vue"
export default component.exports